import { render, staticRenderFns } from "./FooterNegativo.vue?vue&type=template&id=4fa1d9bd&"
import script from "./FooterNegativo.vue?vue&type=script&lang=js&"
export * from "./FooterNegativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports